const PLEASE_DELETE_THIS_BEFORE_DEPLOY = () => {
  if (localStorage.getItem("admintoken") === undefined) {
  }
};
const DEBUG_MESSAGE = (message) => {
  return `######################\n<Notice Page Debug>\n######################\n\n message title: ${message}\n\n<VALUE>\n`;
};
const CREATE_DATA = {
  titles: ["test", "test"],
  urls: ["www.google.com", "www.naver.com"],
  title: "Test Notice Title",
  image: "www.imageUrl.com",
  content:
    "Test Notice Content Test Notice Content Test Notice Content Test Notice Content Test Notice Content Test Notice Content Test Notice Content Test Notice Content",
  pin: false,
};

export { CREATE_DATA, DEBUG_MESSAGE, PLEASE_DELETE_THIS_BEFORE_DEPLOY };
